export const theme = {
  colors: {
    primary: '#2C3E50', // Deep blue
    secondary: '#8B4513', // Rich brown
    accent: '#3498DB', // Bright blue
    background: '#0A0A0A', // Darker background
    text: '#FFFFFF', // Pure white
    textSecondary: '#888888', // Muted gray
  },
  fonts: {
    main: "'Inter', sans-serif",
  },
  spacing: {
    small: '1rem',
    medium: '2rem',
    large: '4rem',
  },
  breakpoints: {
    mobile: '320px',
    tablet: '768px',
    desktop: '1024px',
  },
}; 